export const VISIBLE_USERS_FETCH_SUCCESS = '@@constants/VISIBLE_USERS_FETCH_SUCCESS'
